var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/jsBridge.js
var PubSub = class {
  constructor() {
    this.handlers = {};
  }
  on(topic, handler) {
    if (!this.handlers[topic]) {
      this.handlers[topic] = [];
    }
    this.handlers[topic].push(handler);
  }
  emit() {
    let topic = Array.prototype.shift.call(arguments);
    if (!this.handlers[topic]) {
      return false;
    }
    for (let i = 0; i < this.handlers[topic].length; i++) {
      let handler = this.handlers[topic][i];
      handler.apply(this, arguments);
    }
  }
  off(topic, handler) {
    let handlers = this.handlers[topic];
    if (!handler) {
      handlers.length = 0;
    } else {
      for (let i = 0; i < handlers.length; i++) {
        let _handle = handlers[i];
        if (_handle === handler) {
          handlers.splice(i, 1);
        }
      }
    }
  }
};
var pubSub = new PubSub();
function jsBridge(type, data, callback, { topic = `${type}_${Date.now()}`, randomCallback = true } = {}) {
  return new Promise((resolve, reject) => {
    console.log(type, data, callback);
    const callbackName = callback ? randomCallback ? `${callback}_${Date.now()}` : callback : void 0;
    if (callback) {
      window[callbackName] = (data2) => {
        let resData = typeof data2 === "object" ? data2 : JSON.parse(data2);
        pubSub.emit(topic, resData);
      };
    }
    try {
      if (navigator.userAgent.includes("Android")) {
        if (callback) {
          pubSub.on(topic, (res) => {
            resolve(res);
          });
          android[type](
            JSON.stringify(__spreadProps(__spreadValues({}, data), {
              callback: callbackName
            }))
          );
        } else {
          let result = null;
          if (data) {
            result = android[type](JSON.stringify(data));
          } else {
            result = android[type]();
          }
          console.log("android result:::", result);
          let resData = typeof result === "object" ? result : JSON.parse(result);
          resolve(resData);
        }
      } else if (navigator.userAgent.includes("ArkWeb") || navigator.userAgent.toLowerCase().includes("openharmony")) {
        if (callback) {
          pubSub.on(topic, (res) => {
            resolve(res);
            console.log("harmony:::::::::", res);
          });
          harmony[type](
            JSON.stringify(__spreadProps(__spreadValues({}, data), {
              callback: callbackName
            }))
          );
        } else {
          let result = null;
          if (data) {
            result = harmony[type](JSON.stringify(data));
          } else {
            result = harmony[type]();
          }
          console.log("harmony result:::", result);
          let resData = typeof result === "object" ? result : JSON.parse(result);
          resolve(resData);
        }
      } else {
        pubSub.on(topic, (res) => {
          resolve(res);
        });
        window.webkit.messageHandlers.model.postMessage([
          `${type}:`,
          callback ? __spreadProps(__spreadValues({}, data), {
            callback: callbackName
          }) : data
        ]);
      }
    } catch (error) {
      console.error(error);
      reject("jsbridge\u6267\u884C\u51FA\u9519");
    }
  });
}
var jsBridge_default = {
  pubSub,
  /**
   * 请求都是走promise使用方式
   * @param data
   * @returns {Promise<unknown>}
   */
  addToCalender: (data) => {
    const callback = "app_callback_give_add_calender";
    const params = __spreadProps(__spreadValues({}, data), { callback });
    return jsBridge("jsAppBridgeAddToCalender", params, callback);
  },
  /** 日历中查询某个日程是否存在
   * @param data
   *  title: '测试标题',
   *  startTime: new Date('2023/08/05 14:00').getTime(),
   *  endTime: new Date('2023/08/05 14:01').getTime(),  开始比结束时间多1分钟来查询，不然ios会查不到
   *
   * @returns {Promise<unknown>}
   *  {
   *    result: true | false
   *  }
   */
  checkHasCalender: (data) => {
    let params = {};
    let callback = "";
    try {
      if (!navigator.userAgent.includes("Android")) {
        callback = "app_callback_check_has_calender";
        params = __spreadProps(__spreadValues({}, data), {
          callback
        });
      } else {
        params = __spreadValues({}, data);
      }
    } catch (e) {
      console.log(e);
    }
    console.log("jsAppBridgeCheckHasCalender", params, callback);
    return jsBridge("jsAppBridgeCheckHasCalender", params, callback);
  },
  /**
   * 页面分享
   * @param {*} data
   * share_img 分享图片
   * sharetitle 分享标题
   * sharetxt 分享文案
   * post_image 海报分享的图片 base64
   * post_url_image
   * share_url 分享地址
   * @returns
   */
  appShare: (data) => {
    return jsBridge("jsAppBridgeShare", data);
  },
  /**
   * 获取用户信息
   * @param {*} data
   * @returns
   */
  getUserInfo: () => {
    if (navigator.userAgent.includes("Android") || navigator.userAgent.includes("ArkWeb") || navigator.userAgent.toLowerCase().includes("openharmony")) {
      return jsBridge("getLoginUserInfo");
    } else {
      const callback = "app_callback_giveToken";
      const params = {
        callback
      };
      return jsBridge("getUserLoginInfo", params, callback);
    }
  },
  /**
   * 获取附近经纬度
   * @param {*} data
   * @returns
   */
  getNearbyLocation: () => {
    if (navigator.userAgent.includes("Android") || navigator.userAgent.includes("ArkWeb") || navigator.userAgent.toLowerCase().includes("openharmony")) {
      return jsBridge("jsAppBridgeGetNearbyLocation");
    } else {
      const callback = "app_callback_getNearByInfo";
      const params = {
        callback
      };
      return jsBridge("jsAppBridgeGetNearbyLocation", params, callback);
    }
  },
  /**
   * h5投递跳转app拦截
   * @param jobId 职位id 必填
   * @param resumeId 投递的简历id 可选
   * @param jobType 职位类型 可选
   * @param adId 广告id 可选
   * @param topic 默认为jsAppBridgeApplyJob
   * @returns
   */
  applyJob: (data, topic = "jsAppBridgeApplyJob") => {
    const callback = "ApplyJob";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeApplyJob", params, callback, {
      topic
    });
  },
  /**
   * 获取手机系统对app的通知权限的开关状态
   * @returns Promise<Boolean> true: 打开; false: 关闭
   */
  getPhoneSystemSwitch: () => {
    if (navigator.userAgent.includes("Android") || navigator.userAgent.includes("ArkWeb") || navigator.userAgent.toLowerCase().includes("openharmony")) {
      return jsBridge("jsAppBridgeGetPhoneSystemSwitch");
    } else {
      const callback = "app_callback_getPhoneSystemSwitch";
      const params = {
        callback
      };
      return jsBridge("jsAppBridgeGetPhoneSystemSwitch", params, callback).then(
        (obj) => {
          return obj && obj.phoneSystemSwitch;
        }
      );
    }
  },
  /**
   * 通知H5对专区有订阅或者取消订阅行为
   * @param {Object} data {subscribe: 0}
   * @param subscribe 订阅状态  0：取消订阅， 1：订阅
   * @param zoneIds 订阅专区id，参数类型： [String]
   * @returns
   */
  zoneSubscribe: (data) => {
    return jsBridge("jsAppBridgeZoneSubscribe", data);
  },
  /**
   * 购买产品
   * @param {Object} data {productId: ''}
   * @returns Promise<{payStatus: 1}>
   */
  buyProduct: (data) => {
    const callback = "jsAppBridgeCallbackBuyProduct";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeBuyProduct", params, callback, {
      randomCallback: false
    });
  },
  /**
   * 复购（仅 iOS
   * @param {Object} data
   * @returns
   */
  restore: (data) => {
    return jsBridge("jsAppBridgeRestore", data);
  },
  /**
   * 增值服务 VIP卡下单时, 通知 App
   * @param {Object} data {orderId: ''}
   * @returns
   */
  saveVipOrderId: (data) => {
    return jsBridge("jsAppBridgeSaveVipOrderId", data);
  },
  /**
   * 任务打点
   * @param {Object} options
   * @param {number} options.step2Add 步长 默认是1，同时投递多个职位时传投递的数量
   * @param {string} options.actionType 触发任务步数的动作类型
   * @param {object} options.actionParam 额外参数 object 关注专区任务传专区id，投递任务传投递页面等等（flowId  productId  pageCode）
   * @returns
   */
  jsAppBridgeTask: ({ step2Add = 1, actionType, actionParam }) => {
    return jsBridge("jsAppBridgeTask", {
      step2Add,
      actionType,
      actionParam: navigator.userAgent.includes("Android") || navigator.userAgent.includes("ArkWeb") || navigator.userAgent.toLowerCase().includes("openharmony") ? JSON.stringify(actionParam) : actionParam
    });
  },
  /**
   * h5页显示任务球
   * @returns Promise<void>
   */
  showTaskBall() {
    const callback = "jsAppBridgeShowTaskBall";
    return jsBridge("jsAppBridgeShowTaskBall", { callback }, callback);
  },
  /**
   * 创建简历之前关注会场
   * @param {Object} data
   * @param {String} data.id
   * @returns
   */
  appBridgeSubscribeSubject: (data) => {
    return jsBridge("jsAppBridgeSubscribeSubject", data);
  },
  /**
   * 打开出生年月选择器
   * @param birthday 出生日期
   * @returns
   */
  appBridgeChooseBirthday: (data) => {
    const callback = "app_callback_ChooseBirthday";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseBirthday", params, callback);
  },
  /**
   * 将身份选择结果传给app
   * @param identity 身份
   * @returns
   */
  appBridgeIdentity: (data) => {
    return jsBridge("jsAppBridgeIdentity", data);
  },
  /**
   * 进行实名认证
   * @returns
   */
  appBridgeCertification: () => {
    const callback = "app-jsAppBridgeCertification";
    return jsBridge("jsAppBridgeCertification", { callback }, callback);
  },
  /**
   * 进入上传/解析附件简历页
   * @returns
   */
  appBridgeAttachmentResume: () => {
    return jsBridge("jsAppBridgeAttachmentResume");
  },
  /**
   * 打开学历选择器
   * @param degree 学历code, 参数类型： String
   * @param degreeText 学历value,参数类型： String
   * @param isFullTime 是否是全日制, 参数类型： Bool
   * @param isTopDegree 是否是最高学历, 参数类型： Bool
   * @param callback  js回调方法, 参数类型： String
   * @returns
   */
  appBridgeChooseDegree: (data) => {
    const callback = "app_callback_ChooseDegree";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseDegree", params, callback);
  },
  /**
   * 打开开始工作时间选择器
   * @param birthday 已选出生年月，参数类型： String
   * @param workYearMonth 已选开始工作时间，参数类型： String
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseStartWorkTime: (data) => {
    const callback = "app_callback_ChooseStartWorkTime";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseStartWorkTime", params, callback);
  },
  /**
   * 打开选择居住地页面
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseArea: () => {
    const callback = "app_callback_ChooseArea";
    const params = {
      // ...data,
      callback
    };
    return jsBridge("jsAppBridgeChooseArea", params, callback);
  },
  /**
   * 打开选择户口所在地页面
   * @param code 城市code，参数类型： String
   * @param value 城市value，参数类型： String
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseHousehold: (data) => {
    const callback = "app_callback_ChooseHousehold";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseHousehold", params, callback);
  },
  /**
   * 打开政治面貌选择器
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChoosePolitical: () => {
    const callback = "app_callback_ChoosePolitical";
    const params = {
      // ...data,
      callback
    };
    return jsBridge("jsAppBridgeChoosePolitical", params, callback);
  },
  /**
   * 打开是否有实习经历选择器
   * @param code 有=1/无=0，参数类型： String
   * @param value 有/无，参数类型： String
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChoosePractice: (data) => {
    const callback = "app_callback_ChoosePractice";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChoosePractice", params, callback);
  },
  /**
   * 打开邮箱编辑页
   * @param email 邮箱，参数类型： String
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeEditEmail: (data) => {
    const callback = "app_callback_EditEmail";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeEditEmail", params, callback);
  },
  /**
   * 获取邮箱是否已绑定
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeEmailIsBind: () => {
    const callback = "app_callback_EmailIsBind";
    const params = {
      callback
    };
    return jsBridge("jsAppBridgeEmailIsBind", params, callback);
  },
  /**
   * 打开学校输入页
   * @param value 学校名，参数类型： String
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeInputSchool: (data) => {
    const callback = "app_callback_InputSchool";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeInputSchool", params, callback);
  },
  /**
   * 打开在校时间选择器
   * @param isStart 是否入学时间，参数类型：Bool
   * @param selectedTime 已选时间，参数类型：string
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseSchoolTime: (data) => {
    const callback = "app_callback_ChooseSchoolTime";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseSchoolTime", params, callback);
  },
  /**
   * 打开选择专业页面
   * @param code 已选专业code，参数类型：string
   * @param value 已选专业value，参数类型：string
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseMajor: (data) => {
    const callback = "app_callback_ChooseMajor";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseMajor", params, callback);
  },
  /**
   * 打开公司输入页
   * @param value 公司名，参数类型： String
   * @param isRequire 公司是否必填，参数类型： Bool
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeInputCompany: (data) => {
    const callback = "app_callback_InputCompany";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeInputCompany", params, callback);
  },
  /**
   * 打开在职时间选择器
   * @param isStart 是否开始时间，参数类型：Bool
   * @param birthday 出生年月，参数类型：string
   * @param selectedTime 已选时间，参数类型：string
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseWorkTime: (data) => {
    const callback = "app_callback_ChooseWorkTime";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseWorkTime", params, callback);
  },
  /**
   * 打开职位选择页
   * @param workFunction 已选职位code，参数类型：string
   * @param position 已选职位value，参数类型：string
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChoosePosition: (data) => {
    const callback = "app_callback_ChoosePosition";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChoosePosition", params, callback);
  },
  /**
   * 打开工作描述输入页
   * @param value 描述内容，参数类型：string
   * @param function 职位code，参数类型：string
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeInputJobDescribe: (data) => {
    const callback = "app_callback_InputJobDescribe";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeInputJobDescribe", params, callback);
  },
  /**
   * 打开相关技能页
  * @param functionString 已选职位value，参数类型：Bool
  * @param scene 场景参数，参数类型：string（注册后“register”）
  * @param selectedSkills 已选技能，参数类型：Array
    ["isCustomize": bool, "directionCode": string, "direction": string, "skillCode": string, "skill": string]
  * @param skills 推荐技能(/open/resumes/vocational-skills接口返回数据)，参数类型：dictionary
  * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseWorkSkill: (data) => {
    const callback = "app_callback_ChooseWorkSkill";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseWorkSkill", params, callback);
  },
  /**
   * 打开工作类型选择器
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseJobType: () => {
    const callback = "app_callback_ChooseJobType";
    const params = {
      callback
    };
    return jsBridge("jsAppBridgeChooseJobType", params, callback);
  },
  /**
   * 打开行业选择页
   * * @param code 已选行业code，参数类型：string
   * @param value 已选行业value，参数类型：string
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseIndustry: (data) => {
    const callback = "app_callbac_ChooseIndustry";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseIndustry", params, callback);
  },
  /**
   * 打开公司规模选择器
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseCoSize: () => {
    const callback = "app_callback_ChooseCoSize";
    const params = {
      callback
    };
    return jsBridge("jsAppBridgeChooseCoSize", params, callback);
  },
  /**
   * 打开公司性质选择器
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseCoType: () => {
    const callback = "app_callback_ChooseCoType";
    const params = {
      callback
    };
    return jsBridge("jsAppBridgeChooseCoType", params, callback);
  },
  /**
   * 打开期望工作城市选择页
   * @param selectedAreas 已选城市列表 参数类型： 数组
   * @param functionCode 当前选择期望职位列表的第一个职位 code 参数类型：String
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseWorkArea: (data) => {
    const callback = "app_callback_ChooseWorkArea";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseWorkArea", params, callback);
  },
  /**
   * 打开期望职位选择页
   * @param selectedFunctions 已选职能列表 参数类型：数组
   * @param selectedAreaCodes 已选地区 code，“," 拼接 参数类型： String
   * @param restIntentionCount 剩余求职意向可选数量 参数类型：Int
   * @param callback js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseExpectFunction: (data) => {
    const callback = "app_callback_ChooseExpectFunction";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseExpectFunction", params, callback);
  },
  /**
   * 打开职位偏好页
   * @param data 职位偏好问题列表 参数类型参考 /open/preference/show 接口返回值类型
   * @param callback js回调方法 参数类型： String
   * @returns
   */
  appBridgeChoosePreference: (data) => {
    const callback = "app_callback_ChoosePreference";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChoosePreference", params, callback);
  },
  /**
   * 打开期望月薪选择器
   * @param minSalary 薪资下限 参数类型： String
   * @param maxSalary 薪资上限 参数类型： String
   * @param salaryMonth 薪资月数 参数类型： Int
   * @param recommendMinSalary 推荐最低薪资 参数类型： String
   * @param recommendHint 推荐薪资提示 参数类型： String
   * @param callback js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseSalary: (data) => {
    const callback = "app_callback_ChooseSalary";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseSalary", params, callback);
  },
  /**
   * 打开期望行业选择页
   * @param selectedIndustries 已选行业列表,参数类型：数组
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseIntentionIndustry: (data) => {
    const callback = "app_callback_ChooseIntentionIndustry";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseIntentionIndustry", params, callback);
  },
  /**
   * 打开求职状态选择器
   * @param code  求职状态 code,参数类型： String
   * @param value  求职状态 value,参数类型： String
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeChooseJobStatus: (data) => {
    const callback = "app_callback_ChooseJobStatus";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeChooseJobStatus", params, callback);
  },
  /**
   * 暂不填写（回到游客模式）
   * @returns
   */
  appBridgeNotFilledResume: () => {
    return jsBridge("jsAppBridgeNotFilledResume");
  },
  /**
   * 缓存草稿
   * @param info 简历信息，参数类型：dictionary
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeSaveResumeCache: (data) => {
    const callback = "app_callback_SaveResumeCache";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeSaveResumeCache", params, callback);
  },
  /**
   * 获取草稿
   * @param callback  js回调方法 参数类型： String
   * @returns
   */
  appBridgeGetResumeCache: () => {
    const callback = "app_callback_GetResumeCache";
    const params = {
      callback
    };
    return jsBridge("jsAppBridgeGetResumeCache", params, callback);
  },
  /**
   * 新建简历成功
   * @returns
   */
  appBridgeCreateResumeSuccess: () => {
    return jsBridge("jsAppBridgeCreateResumeSuccess");
  },
  /**
   * 简历向导结束后序流程
   * @param sceneParameters   参数类型：String
   * @returns
   */
  appBridgeResumeGuideEnd: (data) => {
    const callback = "app_callback_GetResumeCache";
    const params = __spreadProps(__spreadValues({}, data), {
      callback
    });
    return jsBridge("jsAppBridgeResumeGuideEnd", params, callback);
  },
  /**
   * 传递订单号和skuId（仅安卓）
   * @param {Object} options
   * @param {string} options.orderId 订单 ID
   * @param {string} options.skuId skuId
   */
  saveOrderSkuId({ orderId, skuId }) {
    return jsBridge("jsAppBridgeSaveOrderSkuId", { orderId, skuId });
  },
  /**
   * 打开半屏的新增求职意向界面
   * 取消时, 仅 Android 会返回 false; iOS 不会返回
   * @returns {Promise<{ isSuccess: Boolean }>} isSuccess: 是否添加.
   */
  addIntention() {
    const callback = "app_callback_AddIntention";
    return jsBridge("jsAppBridgeAddIntention", { callback }, callback);
  }
};
export {
  jsBridge_default as default
};
